import PropTypes from 'prop-types';
import AddressProp from '../../../commonComponents/forms/Address/AddressProp';
import OrderHistoryProp from './orderHistoryProp';
import ShippingProp from '../../profile/propTypes/shippingProp';

const propType = {
  billingAddress: PropTypes.shape(AddressProp.propType),
  createdAt: PropTypes.number,
  currency: PropTypes.string,
  deleted: PropTypes.bool,
  discount: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  discountTotal: PropTypes.number,
  history: PropTypes.arrayOf(PropTypes.shape(OrderHistoryProp.propType)),
  owner: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  seller: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  operator: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  paymentId: PropTypes.string,
  products: PropTypes.array,
  shipping: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(ShippingProp.propType),
  ]),
  shippingAddress: PropTypes.shape(AddressProp.propType),
  installationAddress: PropTypes.shape(AddressProp.propType),
  shippingTotal: PropTypes.number,
  status: PropTypes.string,
  subtotal: PropTypes.number,
  tax: PropTypes.number,
  total: PropTypes.number,
  updatedAt: PropTypes.number,
  vat: PropTypes.number,
  _id: PropTypes.string,
  paymentMethodType: PropTypes.string,
  adminNotes: PropTypes.string,
  notes: PropTypes.string,
};

export default { propType };
